import { ListItem, styled, Typography, TypographyProps } from '@mui/material';

import { doNotForwardTheseProps, elevationLevel } from '@/styles';

import { PreQuestionsContainer } from '../../components/components.styled';

export const BranchSelectionDrawerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '.MuiButton-root': {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

export const BranchListCard = styled(PreQuestionsContainer)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `2px solid ${theme.palette.grey[200]}`,
  boxShadow: theme.shadows[elevationLevel.m],
}));

export const BranchContainer = styled(ListItem, {
  shouldForwardProp: doNotForwardTheseProps('isFaded'),
})<{ isFaded?: boolean }>(({ theme, isFaded }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: `${theme.spacing(1.5)} ${theme.spacing(1)}`,
  '.MuiListItemIcon-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    height: 40,
    width: 40,
  },
  opacity: isFaded ? 0.2 : 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const BranchContainerItem = styled(ListItem, {
  shouldForwardProp: doNotForwardTheseProps('isFaded'),
})<{ isFaded?: boolean }>(({ theme, isFaded }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: `${theme.spacing(1.5)} ${theme.spacing(1)}`,
  '.MuiListItemIcon-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    height: 40,
    width: 40,
  },
  opacity: isFaded ? 0.2 : 1,
  display: 'flex',
  gap: theme.spacing(0.5),
}));

export const BranchInformation = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  }),
);

export const BranchPhoneText = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    display: 'flex',
    color: theme.palette.primary.main,
    gap: theme.spacing(0.5),
  }),
);
